import type { HTMLAttributes, ReactNode } from "react";

import clsx from "clsx";

import styles from "./layout.module.css";

type LayoutProps = {
	children: ReactNode;
};

export function Layout({ children }: LayoutProps): ReactNode {
	return (
		<div className={styles.container}>
			<div className={styles.body}>{children}</div>
		</div>
	);
}

export function MainContent(props: HTMLAttributes<HTMLDivElement>): ReactNode {
	return <div {...props} className={clsx(props.className, styles.main)} />;
}
